import { render } from "./BottomNavigationComponent.vue?vue&type=template&id=14f07acd&scoped=true&ts=true&lang=pug"
import script from "./BottomNavigationComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./BottomNavigationComponent.vue?vue&type=script&lang=ts&setup=true"

import "./BottomNavigationComponent.vue?vue&type=style&index=0&id=14f07acd&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-14f07acd"]])

export default __exports__